import Vue from 'vue';
import Router from 'vue-router';
import Home from '@/components/Home';
import Affilates from '@/components/Affilates';
import Contact from '@/components/Contact';
import Projects from '@/components/Projects';
import Team from '@/components/Team';

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home,
    },
    {
      path: '/team',
      name: 'Team',
      component: Team,
    },
    {
      path: '/projects',
      name: 'Projects',
      component: Projects,
    },
    {
      path: '/affilates',
      name: 'Affilates',
      component: Affilates,
    },
    {
      path: 'contact/',
      name: 'Contact',
      component: Contact,
    },
  ],
});



// WEBPACK FOOTER //
// ./src/router/index.js